import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, tokenStore, formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // user: null = checking, false = logged out, object = authenticated
  const [user, setUser] = useState(null);

  const fetchMe = useCallback(async () => {
    if (!tokenStore.get()) {
      setUser(false);
      return;
    }
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch {
      tokenStore.clear();
      setUser(false);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = async (email, password) => {
    try {
      const res = await api.post("/auth/login", { email, password });
      tokenStore.set(res.data.token);
      setUser(res.data.user);
      return { ok: true, user: res.data.user };
    } catch (e) {
      const msg = formatApiErrorDetail(e?.response?.data?.detail) || "Error de autenticación";
      return { ok: false, error: msg };
    }
  };

  const logout = () => {
    tokenStore.clear();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
